const parseLocalDate = (date: string): Date => {
	if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
		const [year, month, day] = date.split('-').map(Number);
		return new Date(year, month - 1, day);
	}
	return new Date(date);
};

const generateDatesForNextWeeks = (startDate: string, numOfWeeks: number): Date[] => {
	const start = parseLocalDate(startDate);
	const days = 7 - start.getDay() + numOfWeeks * 7;
	const dates = [];

	for (let i = 0; i < days; i++) {
		dates.push(new Date(start.getTime() + i * 1000 * 60 * 60 * 24));
	}

	return dates;
};

export default generateDatesForNextWeeks;
